export default __webpack_public_path__ + "static/whitepaper_trz_v1.1_es-f4cd7f95b22147f72826fd8500e29c1b.pdf";